import { Box, Text, Button, Center, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { CheckCircleIcon } from "@chakra-ui/icons";
import Cookies from 'js-cookie'; 
import { useEffect, useMemo } from "react";
import { useState } from "react"; 
import axios from "axios"; 
import { useAuth } from '../Components/auth/AuthProvider';

export default function WaveLandingPage() {

  const [paymentComplete, paymentCompleteSet] = useState(false);
  const [paymentSuccessful, paymentSuccessfulSet] = useState(false);
  const [amount, setAmount] = useState(null);
  const [transactionDate, setTransactionDate] = useState(null); 
  const { user, token } = useAuth();

  const config = useMemo(() => ({ 
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }), [token]);



  useEffect(() => {

    async function poll() {
      const interval = 5000; // 5 seconds
      const timeout = 300000; // 5 minutes
      const startTime = Date.now();

      let localCompletePayment = false; 

      while (!localCompletePayment && Date.now() - startTime < timeout) {
        try {
          const sessionId = Cookies.get('sessionId');
          console.log(sessionId); 
          const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/wave_integration/check_payment`,
            {
              headers: {
                Authorization: config.headers.Authorization
              },
              params: { id: String(sessionId) },
            }
          );

          const { status, amount, transaction_date } = response.data;
          setAmount(amount);
          setTransactionDate(transaction_date);
          
          if (response.data.status === "Payment Successful") {
            paymentCompleteSet(true);
            paymentSuccessfulSet(true);
            localCompletePayment = true; 
          } else if (response.data.status === "Payment Failed") {
            paymentCompleteSet(true);
            paymentSuccessfulSet(false);
            localCompletePayment = true;
          } else {
            paymentCompleteSet(false);
            paymentSuccessfulSet(false);
          }

        } catch (error) {
          console.error("Polling error:", error);
        }

        if (!localCompletePayment) {
          await new Promise(resolve => setTimeout(resolve, interval));
        }
        
      }

      if (!localCompletePayment) {
        paymentCompleteSet(true);
        paymentSuccessfulSet(false);
        await new Promise(resolve => setTimeout(resolve, interval));
      }
    }


    poll()

    }, []);


    return (
      <ActualPage paymentComplete={paymentComplete} paymentSuccessful={paymentSuccessful} amount={amount} transactionDate={transactionDate} ></ActualPage>
    )
}



//probably should do some work around this later 
function ActualPage({ paymentComplete, paymentSuccessful, amount, transactionDate }) {


  const navigate = useNavigate();

  function getPaymentStatusText(paymentComplete, paymentSuccessful) {
    if(paymentComplete) {
      return paymentSuccessful ? "Payment Successful" : "Payment Failed";
    } else {
      return "Waiting on Server Response" 
    }
  }

  function formatCurrency(value) {
    if (value == null) return "";
    try {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "GMD",
        minimumFractionDigits: 2,
      }).format(value);
    } catch {
      return `${value} GMD`;
    }
  }


  return (
    <Box
      minH="100vh"
      display="flex"
      flexDirection="column"
      borderTop="53px solid #00D29D"
      borderBottom="53px solid #00D29D"
      bg="white"
    >
      {/* Top-left JF logo */}
      <Box
        position="absolute"
        top="1px"
        left="16px"
        bg="#00D29D"
        color="white"
        fontWeight="bold"
        fontSize="2xl"
        px={3}
        py={2}
        borderRadius="sm"
      >
        JF
      </Box>
      <Center flex="1" px={4}>
        <VStack spacing={4}>
          {paymentSuccessful && <CheckCircleIcon boxSize={24} color="#00D29D" />}
          <Text fontSize="4xl" fontWeight="bold" color="gray.800">
            {getPaymentStatusText(paymentComplete, paymentSuccessful)}
          </Text>

          {paymentSuccessful && (
            <>
              {amount !== null && (
                <Text fontSize="xl" color="gray.600">
                  Amount: {formatCurrency(amount)}
                </Text>
              )}
              {transactionDate && (
                <Text fontSize="md" color="gray.500">
                  Date: {new Date(transactionDate).toLocaleString()}
                </Text>
              )}
            </>
          )}


          {paymentComplete && <Button
            mt={4}
            bg="black"
            color="white"
            _hover={{ bg: "gray.700" }}
            onClick={() => navigate("/home")}
          >
            Return to Home
          </Button>}
        </VStack>
      </Center>
    </Box>
  );
}
